const Base64 = {
   //加密
    encode(str) {
      if(str != null && str != ""){
        return encodeURIComponent(str);
      }else{
        return "";
      }
    },
  //解密
    decode(str) {
      if(str != null && str != ""){
        // Going backwards: from bytestream, to percent-encoding, to original string.
        return decodeURIComponent(str);
      }else{
        return "";
      }

    }
}
export default Base64;



// WEBPACK FOOTER //
// ./src/common/base64.js